// extracted by mini-css-extract-plugin
export default {"root":"KP1oM","link":"Zz9dF","active":"QNNEp"};